import * as React from 'react';
import cn from 'classnames';
import { PlaceAd } from '../../components';
import { PlaceAdButtonContent } from '../../components/PlaceAdButtonContent';
import { TSection } from '../../../../../repositories/frontend-header/entities/entities';

interface IDealRentNewFormsLinkSchema {
  link: string;
  title: string;
}

interface IPlaceAdContainerProps {
  section: TSection | undefined;
  addObjectLink: string;
  hasNotBlockedSanction: boolean;
  dealRentNewFormsLink?: IDealRentNewFormsLinkSchema | null;
}

export const PlaceAdContainer: React.FC<IPlaceAdContainerProps> = ({
  hasNotBlockedSanction,
  section,
  dealRentNewFormsLink,
  addObjectLink,
}) => {
  if (!hasNotBlockedSanction) {
    return null;
  }
  const isSerp = section === 'serp';
  const isUserArea = section === 'userArea';

  const containerClassName = cn({ 'is-serp': isSerp, 'new-forms-link': dealRentNewFormsLink && !isUserArea });

  if (dealRentNewFormsLink && !isUserArea) {
    return (
      <PlaceAd
        containerClassName={containerClassName}
        link={dealRentNewFormsLink.link}
        buttonContent={dealRentNewFormsLink.title}
      />
    );
  } else {
    return (
      <PlaceAd containerClassName={containerClassName} link={addObjectLink} buttonContent={<PlaceAdButtonContent />} />
    );
  }
};

PlaceAdContainer.displayName = 'PlaceAdContainer';
